import axios from 'axios'
import CryptoJS from 'crypto-js'
import { BASE_API, ROLE, DUENDE_CONFIG } from '../constants'
import Helper from '../services/Helper'
import DuendeTokenManager from '../services/DuendeTokenManager'
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';

const isNullOrEmpty = Helper.isNullOrEmpty

axios.defaults.baseURL = BASE_API
axios.defaults.headers.common.token = localStorage.getItem('token');

// Axios interceptor to scope tokens per API domain
axios.interceptors.request.use(
  config => {
    const isDuendeRequest = typeof config.url === 'string' && config.url.startsWith('/duende');
    const headers = config.headers || {};

    if (isDuendeRequest) {
      // Only attach Duende access token to Duende endpoints
      const duendeAccessToken = DuendeTokenManager.getAccessToken();
      if (duendeAccessToken && !headers.Authorization) {
        headers.Authorization = `Bearer ${duendeAccessToken}`;
      }
    } else {
      // Ensure application APIs keep using AGC token and avoid leaking Duende credentials
      const agcToken = localStorage.getItem('token');
      if (agcToken) headers.token = agcToken;
      if (headers.Authorization && DuendeTokenManager.isDuendeAuth()) delete headers.Authorization;
    }

    config.headers = headers;
    return config;
  },
  error => Promise.reject(error)
);

const config = {
  headers: { 'Content-Type': 'multipart/form-data' },
}
//Auth
function login(data) {
  return axios.post('/login', data)
}

function verifyOtp(data) {
  return axios.post('/verify-otp', data)
}

function getTokenForgotPassword(props) {
  let formData = props.formData || {}
  return axios.post('/forgot-password', formData)
}

function validateTokenForgotPassword(props) {
  let formData = props.formData || {}
  return axios.put('/forgot-password', formData)
}

function userChangePassword(props) {
  let formData = props.formData || {}
  return axios.put('/user-change-password', formData)
}

//===========================================
// MASTER PERUSAHAAN
//===========================================
function getPerusahaan(paramEncoded) {
  return axios.get(`/perusahaan?${paramEncoded}`)
}
function getPerusahaanLimit(paramEncoded) {
  return axios.get(`/perusahaan-limit?${paramEncoded}`)
}
function getPerusahaanDetail(id, params) {
  return axios.get(`/perusahaan/${id}?${params}`)
}

const postFieldsPerusahaan = [
  'nama',
  'masterJenisPerusahaanId',
  'masterJenisPerusahaanIds',
  'defaultMasterJenisPerusahaanId',
  'masterProvinsiId',
  'alamat', 
  'teleponFax', 
  'luasTanahBangunan', 
  'jumlahKaryawan', 
  'produk', 
  'directorInCharge', 
  'managementRepresentative', 
  'personInCharge',
  'masterParentPerusahaanId',

  'username1', 'email1', 'password1', 'retypePassword1', 'roleId1', // untuk user
  'username2', 'email2', 'password2', 'retypePassword2', 'roleId2', // untuk user
]

function createMasterPerusahaan(data) {
  let formData = {}
  let postFields = postFieldsPerusahaan
  for (let field of postFields) {
    formData[field] = data[field]
  }
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.post('/perusahaan', {data: formData})
}

function updateMasterPerusahaan(id, data) {
  let formData = {}
  let postFields = postFieldsPerusahaan
  for (let field of postFields) {
    formData[field] = data[field]
  }
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.put(`/perusahaan/${id}`, {data:formData})
}
function deleteMasterPerusahaan(id) {
  // const encryptedId = CryptoJS.AES.encrypt(String(id), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.delete(`/perusahaan/${id}`)
}
function getJenisPerusahaan(paramEncoded) {
  return axios.get(`/jenis-perusahaan-all?${paramEncoded}`)
}


function getUserAsessorOnPerusahaan(id, params) {
  return axios.get(`/perusahaan/${id}/users?${params}&roleId=6`)
}

function createUserPerusahaan(data) {
  let formData = {}
  let postFields = ['userId', 'masterPerusahaanId']

  for (let field of postFields) {
    formData[field] = data[field]
  }
  return axios.post('/user-perusahaan', formData)
}

function selectAllUserPerusahaan(props = {}) {
  let formData = props.formData || {}
  return axios.post('/user-perusahaan/all', formData)
}
function deleteUserPerusahaan(id) {
  return axios.delete(`/user-perusahaan/${id}`)
}
function deleteUserPerusahaanAll(data) {
  let formData = {}
  let postFields = ['userId']

  for (let field of postFields) {
    formData[field] = data[field]
  }

  return axios.post(`/delete-all-user-perusahaan`, formData)
}

//===========================================
// MASTER USER
//===========================================
function getRole(paramEncoded) {
  return axios.get(`/role?${paramEncoded}`)
}

function getUser(paramEncoded) {
  return axios.get(`/user?${paramEncoded}`)
}

function getUserDetail(id, params) {
  return axios.get(`/user/${id}?${params}`)
}

const postFieldsUser = ['username', 'email', 'password', 'retypePassword', 'roleId', 'masterPerusahaanId', 'masterPerusahaanIds', 'adminId', 'multipleRoles', 'noTelpon', 'masterParentPerusahaanId']

function createMasterUser(data) {
  let formData = {}
  let postFields = postFieldsUser

  for (let field of postFields) {
    formData[field] = data[field]
  }
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.post('/user', {data:formData})
}

function updateMasterUser(id, data) {
  let formData = {}
  let postFields = postFieldsUser

  for (let field of postFields) {
    formData[field] = data[field]
  }
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.put(`/user/${id}`, {data:formData})
}

function actionMasterUser(id, action) {
    return axios.put(`/user/${action}/${id}`)
}

function deleteMasterUser(id) {
  return axios.delete(`/user/${id}`)
}

function getPerusahaanOnUser(id, params) {
  return axios.get(`/user/${id}/perusahaan?${params}`)
}

//===========================================
// MASTER SHEET
//===========================================
function getSheet(paramEncoded) {
  return axios.get(`/sheet?${paramEncoded}`)
}

function createSheet(data) {
  let formData = {}
  let postFields = ['nama', 'typePenilaian']
  for (let field of postFields) {
    formData[field] = data[field]
  }
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.post('/sheet', {data:formData})
}

function updateSheet(id, data) {
  let formData = {}
  let postFields = ['nama', 'typePenilaian']
  for (let field of postFields) {
    formData[field] = data[field]
  }
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.put(`/sheet/${id}`, {data:formData})
}

function getKriteria(paramEncoded) {
  return axios.get(`/kriteria?${paramEncoded}`)
}

function getKriteriaAgc(data) {
  let {tahun, masterJenisPerusahaanId} = data
  return axios.get(`/kriteria-agc/${tahun}/${masterJenisPerusahaanId}`)
}

function getSubKriteriaAgc(data) {
  let {masterKriteriaId} = data
  return axios.get(`/subkriteria-agc/${masterKriteriaId}`)
}

function getProvinsi(paramEncoded) {
  return axios.get(`/provinsi?${paramEncoded}`)
}

function getSheetPerusahaan(paramEncoded) {
  return axios.get(`/sheet-perusahaan?${paramEncoded}`)
}

function fetchSheetPerusahaan(props) {
  let params = props.params || ''
  return axios.get(`/sheet/perusahaan?${params}`)
}

function sheetPerusahaan(params, paramEncoded) {
  return axios.get(`/sheet-perusahaan/${params.masterJenisPerusahaanId}/${params.tahunId}?${paramEncoded}`)
}

function getSheetTahun() {
  return axios.get('/sheet-tahun')
}

function getListKriteria(paramEncoded) {
  return axios.get(`/sheet/list-kriteria?${paramEncoded}`)
}

function getListSubKriteria(paramEncoded) {
  return axios.get(`/sheet/list-sub-kriteria?${paramEncoded}`)
}

function createJenisSheet(data) {
  let formData = {}
  let postFields = ['masterJenisPerusahaanId', 'masterSheetId']
  for (let field of postFields) {
    formData[field] = data[field]
  }
  return axios.post('/jenis-sheet', formData)
}

function getPertanyaanPerSheet(masterPerusahaanId, masterSheetId, params = null) {
  return axios.get(`/pertanyaan/${masterPerusahaanId}/${masterSheetId}?${params}`)
}

function updatePenilaian(id, data) {
  let formData = new FormData()
  if (data.bukti) formData.append('bukti', data.bukti)
  if (data.komentar || data.komentar === '') formData.append('komentar', data.komentar)
  if (data.nilai || data.nilai === '') formData.append('nilai', data.nilai)
  if (data.confirm === true || data.confirm === false) formData.append('confirm', data.confirm)

  let dataField = [
    'nilaiAkhir',
    'nilaiDetail',
    'status',
    //khusus form angka ////////////
    'totalSE',
    'totalA',
    'persentaseAkhir',
    //khusus form FRSR /////////////
    'bulan',
    'periode',
    'jumlahKaryawan',
    'jumlahJamKerja',
    'jumlahJamKerjaKaryawan',
    'jumlahKecelakaan',
    'jumlahHariHilang',
    'totalJumlahKaryawan',
    'totalJumlahJamKerja',
    'totalJumlahJamKerjaKaryawan',
    'totalJumlahKecelakaan',
    'totalJumlahHariHilang',
    'jumlahKaryawanBulanAkhir',
    'FR',
    'SR',
    //khusus form TKTF /////////////
    'totalVolumeLaluLintas',
    'totalAverageJarakTempuh',
    'totalAveragePerBulan',
    'totalDampakLukaRingan',
    'totalDampakLukaBerat',
    'totalDampakMati',
    'TK',
    'TF',
    'volume_lalu_lintas',
    'average_jarak_tempuh',
    'average_per_bulan',
    'jumlah_kecelakaan',
    'dampak_luka_ringan',
    'dampak_luka_berat',
    'dampak_mati',
    ]
  
  for (let field of dataField) {
    if (!isNullOrEmpty(data[field])) formData.append(`${field}`, data[field]) 
  }
  
  return axios.put(`/penilaian-asessor/${id}`, formData, config)
}

function deleteFileBukti(data) {
  const formData = Helper.encrypt(data, false)
  return axios.post('/penilaian-asessor/delete-bukti', {data: formData})
}

function updateDataLocal(data) {
  return axios.post('/penilaian-asessor/update-data-local', data)
}

function updatePenilaianPeriode(data) {
  return axios.put('/periode-penilaian-asessor', data)
}

function updateExecutiveSummary(data) {
  const formData = Helper.encrypt(data, false)
  return axios.post('/update-executive-summary', {data: formData})
}

function getExecutiveSummary(paramEncoded) {
  return axios.get(`/executive-summary?${paramEncoded}`)
}
function saveKomentarAstra(data) {
  return axios.put('/executive-summary/save-komentar-astra', data)
}

function generatePdf(data) {
  let keys = Object.keys(data)
  let params = [];
  if (typeof keys === 'object' && keys.length > 0) {
    for (let i = 0; i < keys.length; i++) {
      params.push(`${keys[i]}=${data[keys[i]]}`)
    }
  }
  params = encodeURI(params.join('&'))
  
  return axios.get(`/generate-pdf?${params}`)
}

function generatePerusahaan(data) {
  return axios.post('/generate-pdf/perusahaan', data)
}

function getTahun(paramEncoded) {
  return axios.get(`/tahun?${paramEncoded}`)
}

function getTahunJenisPerusahaan(masterJenisPerusahaanId) {
  return axios.get(`/jenis-perusahaan/tahun/${masterJenisPerusahaanId}`)
}

function deleteJenisPerusahaan(data) {
  let {tahun, masterJenisPerusahaanId} = data
  return axios.get(`/jenis-perusahaan/delete/${tahun}/${masterJenisPerusahaanId}`)
}

function getNilaiFrSr(perusahaanId, query) {
  return axios.get(`/nilai-fr-sr/${perusahaanId}?${query}`)
}

function getFrSr(perusahaanId, query) {
  return axios.get(`/fr-sr/${perusahaanId}?idfr=${query.idfr}&idsr=${query.idsr}&tahun=${query.tahun}`)
}

function pimpinanApprove(data) {
  return axios.post('/pimpinan-approve', data)
}
function astraApprove(data) {
  return axios.post('/astra-approve', data)
}
function picEditable(id, data) {
  return axios.put(`/pic-editable/${id}`, data)
}
function changeJenisAssessment(id, data) {
  return axios.put(`/perusahaan/jenis-assessment/${id}`, data)
}
function kepalaApprove(data) {
  return axios.post('/executive-summary/kepala-approve', data)
}
function getStatistikNilaiPerTahun(params) {
  let account = Helper.getUser()
  let masterPerusahaanIds = account.roleId === ROLE.ADMIN_PUSAT ? [] : account.masterPerusahaanIds

  return axios.get(`/statistik-nilai?${params}&masterPerusahaanIds=${masterPerusahaanIds}`)
}
function getStatistikNilaiRangeTahun(props) {
  let params = props.params || ''
  if (params) params += '&'
  let account = Helper.getUser()
  let masterPerusahaanIds = []
  if (Array.isArray(account.masterPerusahaanIds) && account.masterPerusahaanIds.length > 0) {
    masterPerusahaanIds = account.masterPerusahaanIds
  }
  if (Array.isArray(props.masterPerusahaanIds) && props.masterPerusahaanIds.length > 0) {
    masterPerusahaanIds = props.masterPerusahaanIds
  }
  masterPerusahaanIds = account.roleId === ROLE.ADMIN_PUSAT ? [] : account.masterPerusahaanIds
  
  return axios.get(`/statistik-nilai/range?${params}masterPerusahaanIds=${masterPerusahaanIds}`)
}

function getStatistikNilaiRangeTahunPerPerusahaan(params) {
  return axios.get(`/statistik-nilai-perusahaan/range?${params}`)
}
function getPetaStatus(params) {
  let account = Helper.getUser()
  const masterPerusahaanIds = account.roleId === ROLE.ADMIN_PUSAT ? [] : account.masterPerusahaanIds
  
  return axios.get(`/peta-status?${params}&masterPerusahaanIds=${masterPerusahaanIds}`)
}

function getMasterPertanyaan(sheetPerusahaanId) {
  return axios.get(`/get-master-pertanyaan/${sheetPerusahaanId}`)
}
function editKriteria(data) {
  return axios.post('/edit-kriteria', data)
}
function editSubKriteria(data) {
  return axios.post('/edit-sub-kriteria', data)
}
function editPertanyaan(data) {
  return axios.post('/edit-pertanyaan', data)
}
function addPertanyaan(data) {
  return axios.post('/sheet/add-pertanyaan', data)
}
function addKriteria(data) {
  return axios.post('/sheet/add-kriteria', data)
}
function addSubKriteria(data) {
  return axios.post('/sheet/add-sub-kriteria', data)
}
function deletePertanyaan(data) {
  return axios.post('/sheet/delete-pertanyaan', data)
}
function deleteKriteria(data) {
  return axios.post('/sheet/delete-kriteria', data)
}
function deleteSubKriteria(data) {
  return axios.post('/sheet/delete-sub-kriteria', data)
}
function sortPertanyaan(id, data) {
  return axios.put(`/sheet/sort-pertanyaan/${id}`, data)
}
function sortKriteria(id, data) {
  return axios.put(`/sheet/sort-kriteria/${id}`, data)
}
function sortSubKriteria(id, data) {
  return axios.put(`/sheet/sort-sub-kriteria/${id}`, data)
}
function uploadPhotoFormTemuan(data) {
  let formData = new FormData()
  let keys = Object.keys(data)
  for (let i = 0; i < keys.length; i++) {
    let name = keys[i]
    formData.append(name, data[name])
  }
  return axios.post('/form-temuan/upload-photo', formData)
}
function updatePhotoFormTemuan(data) {
  let formData = new FormData()
  let keys = Object.keys(data)
  for (let i = 0; i < keys.length; i++) {
    let name = keys[i]
    formData.append(name, data[name])
  }
  return axios.post('/form-temuan/update-photo', formData)
}
function addPhoto2Temuan(data) {
  let formData = new FormData()
  let keys = Object.keys(data)
  for (let i = 0; i < keys.length; i++) {
    let name = keys[i]
    formData.append(name, data[name])
  }
  return axios.post('/form-temuan/add-photo-2', formData)
}
function updatePhoto2FormTemuan(data) {
  let formData = new FormData()
  let keys = Object.keys(data)
  for (let i = 0; i < keys.length; i++) {
    let name = keys[i]
    formData.append(name, data[name])
  }
  return axios.post('/form-temuan/update-photo-2', formData)
} 
function updateStatusTemuan(data) {
  const formData = Helper.encrypt(data, false)
  return axios.post('/form-temuan/update-status', {data: formData})
}
function addHeaderTemuan(data) {
  return axios.post('/form-temuan/add-header', data)
}
function getFormTemuan(data) {
  let {
    masterPerusahaanId,
    tahun
  } = data

  return axios.get(`/form-temuan/${masterPerusahaanId}/${tahun}`)
}
function deleteFormTemuan(formTemuanId) {
  return axios.post('/form-temuan/delete-temuan', {formTemuanId})
}
function deleteHeaderTemuan(headerFormTemuanId) {
  return axios.post('/form-temuan/delete-header', {headerFormTemuanId})
}
function updateHeaderFormTemuan(data) {
  return axios.post('/form-temuan/update-header', data)
}
function updateDetailTemuan(data) {
  const formData = Helper.encrypt(data, false)
  return axios.post('/form-temuan/update-detail-temuan', {data:formData})
}
function uploadGambarHome(data) {
  let formData = new FormData()
  let {gambarhome} = data
  formData.append('gambarhome', gambarhome)
  return axios.post('/upload-gambar-home', formData)
}
function getGambarHome() {
  return axios.get('/gambar-home')
}
function generateTahun(tahun, option = {}) {
  let params = `?${option.params}` || ''
  return axios.get(`/tahun/generate/${tahun}${params}`)
}
function getStatistikTahun(tahun) {
  return axios.get(`/tahun/statistik/${tahun}`)
}
function deleteTahun(tahun) {
  return axios.delete(`/tahun/${tahun}`)
}
function generateJenisPerusahaan(data) {
  let {tahun, masterJenisPerusahaanId, namaJenisPerusahaan, nomorKriteria} = data
  const formData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.post('/generate/jenis-perusahaan', {data: formData})
}

function getNilaiTkTf(data) {
  return axios.post('/nilai/tk-tf', data)
}

function updateNilaiBeyond(id, data) {
  return axios.put(`/update-nilai-beyond/${id}`, data)
}

function getSettings(props) {
  let params = props.params || ''
  return axios.get(`/settings?${params}`)
}

function getLogs(props) {
  let params = props.params || '';
  return axios.get(`/logs?${params}`);
}

function getLogsByPerusahaan(id, params) {
  return axios.get(`/perusahaan/${id}/logs?${params}`)
}

function getRekapSheet(props) {
  let masterPerusahaanId = props.masterPerusahaanId || ''
  let params = props.params || ''
  return axios.get(`/rekapitulasi-sheet/${masterPerusahaanId}?${params}`);
}

function getPerameterSinkron(props) {
  let masterPerusahaanId = props.masterPerusahaanId || null;
  return axios.get(`/perusahaan/parameter-sinkron/${masterPerusahaanId}`)
}

function sinkronisasiNilaiPerusahaan(props) {
  let masterPerusahaanId = props.masterPerusahaanId || null;
  return axios.get(`/perusahaan/sinkronisasi-nilai/${masterPerusahaanId}`)
}

function synchronizeNilaiPerPerusahaan(props) {
  return axios.get(`/synchronize-nila-perusahaan/${props.masterPerusahaanId || ''}?${props.params || ''}`)
}

function getMetadataGenerateTahun(props) {
  return axios.get('/metadata-generate-tahun');
}

function postStageAssessment(props) {
  let formData = props.formData || {}
  return axios.post('/stage', formData)
}

function nonActiveSelftAssessment(props) {
  let formData = props.formData || {}
  return axios.post('/perusahaan/non-active-self-assessment', formData)
}

function getInfoUser(props) {
  return axios.get('/info-user')
}

function changeRoleMulti(props) {
  let roleId = props.roleId || null
  return axios.post('/change-role-multi', { roleId })
}

function getDetailMasterJenisKriteria(props) {
  let masterJenisPerusahaanId = props.masterJenisPerusahaanId || null
  return axios.get(`/master-jenis-kriteria/${masterJenisPerusahaanId}`);
}

function deleteSheetPerusahaan(props) {
  let sheetPerusahaanId = props.sheetPerusahaanId || null
  return axios.delete(`/sheet-perusahaan/${sheetPerusahaanId}`)
}

function updateJenisPerusahaan(props) {
  let formData = props.formData || {}
  let masterJenisPerusahaanId = props.masterJenisPerusahaanId || null
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.put(`/jenis-perusahaan/${masterJenisPerusahaanId}`, {data:formData})
}

function getMasterParentPerusahaan(props = {}) {
  let params = props.params || ''
  return axios.get(`/parent-perusahaan?${params}`)
}

function createMasterParentPerusahaan(props) {
  let formData = props.formData || {}
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.post('/parent-perusahaan', {data:formData})
}

function updateMasterParentPerusahaan(props) {
  let formData = props.formData || {}
  formData = CryptoJS.AES.encrypt(JSON.stringify(formData), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.put('/parent-perusahaan', {data: formData})
}

function deleteMasterParentPerusahaan(props) {
  let formData = props.formData || {}
  const id = CryptoJS.AES.encrypt(String(formData.id), process.env.REACT_APP_SECRET_KEY).toString()
  return axios.delete(`/parent-perusahaan/${formData.id}`)
}

function getSinkronisasiNilaiPerusahaan(props) {
  let params = props.params || ''
  return axios.get(`/sinkronisasi-nilai-perusahaan?${params}`)
}

function updatePersetujuanKepala(props) {
  let masterPerusahaanId = props.masterPerusahaanId || ''
  let formData = props.formData || {}
  return axios.put(`/perusahaan/persetujuan-kepala/${masterPerusahaanId}`, formData)
}

function updateIncludeBeyond(data) {
  return axios.post('/update-include-beyond', data)
}

function getLogsApp(params) {
  params = params || ''
  return axios.get(`/logs-app?${params}`)
}

function getLogsAppDetail(id) {
  return axios.get(`/logs-app/${id}`)
}

const ApiCall = {
  fetchSheetPerusahaan,
  selectAllUserPerusahaan,
  getTokenForgotPassword,
  validateTokenForgotPassword,
  userChangePassword,

  updatePersetujuanKepala,
  getSinkronisasiNilaiPerusahaan,
  
  getMasterParentPerusahaan,
  createMasterParentPerusahaan,
  updateMasterParentPerusahaan,
  deleteMasterParentPerusahaan,

  login,
  verifyOtp,

  getRole,
  getUser,
  getUserDetail,
  createMasterUser,
  updateMasterUser,
  actionMasterUser,
  deleteMasterUser,
  getPerusahaanOnUser,

  getPerusahaan,
  getPerusahaanLimit,
  getPerusahaanDetail,
  createMasterPerusahaan,
  updateMasterPerusahaan,
  deleteMasterPerusahaan,
  getJenisPerusahaan,
  getUserAsessorOnPerusahaan,
  createUserPerusahaan,
  deleteUserPerusahaan,
  deleteUserPerusahaanAll,
  picEditable,

  getProvinsi,

  getSheet,
  createSheet,
  updateSheet,
  getKriteria,
  getKriteriaAgc,
  getSubKriteriaAgc,

  getSheetPerusahaan,
  sheetPerusahaan,
  createJenisSheet,
  getSheetTahun,

  getPertanyaanPerSheet,

  getListKriteria,
  getListSubKriteria,

  updatePenilaian,
  deleteFileBukti,
  updateDataLocal,
  updatePenilaianPeriode,

  updateExecutiveSummary,
  getExecutiveSummary,
  saveKomentarAstra,
  generatePdf,
  generatePerusahaan,

  getTahun,

  getFrSr,
  getNilaiFrSr,

  getStatistikNilaiPerTahun,
  getStatistikNilaiRangeTahun,
  getStatistikNilaiRangeTahunPerPerusahaan,
  getPetaStatus,
  
  pimpinanApprove,
  astraApprove,
  kepalaApprove,

  getMasterPertanyaan,

  editKriteria,
  editSubKriteria,
  editPertanyaan,
  addPertanyaan,
  addKriteria,
  addSubKriteria,
  deletePertanyaan,
  deleteKriteria,
  deleteSubKriteria,
  sortPertanyaan,
  sortSubKriteria,
  sortKriteria,
  
  uploadPhotoFormTemuan,
  updateStatusTemuan,
  getFormTemuan,
  addHeaderTemuan,
  addPhoto2Temuan,
  deleteFormTemuan,
  updateHeaderFormTemuan,
  updateDetailTemuan,
  updatePhotoFormTemuan,
  updatePhoto2FormTemuan,
  deleteHeaderTemuan,
  
  uploadGambarHome,
  getGambarHome,

  generateTahun,
  getTahunJenisPerusahaan,
  deleteJenisPerusahaan,
  deleteTahun,
  generateJenisPerusahaan,
  getStatistikTahun,

  getNilaiTkTf,
  updateNilaiBeyond,
  getSettings,
  getLogs,
  getLogsByPerusahaan,
  
  getRekapSheet,

  getPerameterSinkron,
  sinkronisasiNilaiPerusahaan,
  getMetadataGenerateTahun,
  synchronizeNilaiPerPerusahaan,
  postStageAssessment,
  changeJenisAssessment,
  nonActiveSelftAssessment,
  getInfoUser,
  changeRoleMulti,

  getDetailMasterJenisKriteria,
  deleteSheetPerusahaan,
  updateJenisPerusahaan,
  updateIncludeBeyond,

  getLogsApp,
  getLogsAppDetail,
}

//===========================================
// DUENDE IDENTITYSERVER
//===========================================
/**
 * Get Duende configuration from backend
 */
function getDuendeConfig() {
  return axios.get('/duende/config')
}

/**
 * Get user info from Duende token
 * @param {string} accessToken - Duende access token
 */
function getDuendeUserInfo(accessToken) {
  return axios.post('/duende/userinfo', { accessToken })
}

/**
 * Introspect Duende token (validate token)
 * @param {string} token - Token to validate
 */
function introspectDuendeToken(token) {
  return axios.post('/duende/introspect', { token })
}

/**
 * Revoke Duende token
 * @param {string} token - Token to revoke
 * @param {string} tokenTypeHint - 'access_token' or 'refresh_token'
 */
function revokeDuendeToken(token, tokenTypeHint = 'access_token') {
  return axios.post('/duende/revoke', { token, tokenTypeHint })
}

/**
 * Sync Duende user with AGC system
 * @param {object} userInfo - User info from Duende
 * @param {string} accessToken - Duende access token
 */
function syncDuendeUser(userInfo, accessToken) {
  return axios.post('/duende/sync-user', { userInfo, accessToken })
}

/**
 * Test Duende token (protected route)
 * @param {string} token - Duende access token
 */
function testDuendeToken(token) {
  return axios.get('/duende/test', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

/**
 * Exchange authorization code for tokens via backend proxy
 * This avoids CORS issues by routing through AGC backend
 * @param {string} code - Authorization code from Duende
 * @param {string} codeVerifier - PKCE code verifier
 */
async function exchangeCodeForTokens(code, codeVerifier) {
  try {
    // Call backend which will forward to Duende token endpoint
    const response = await axios.post('/duende/exchange-token', {
      code,
      codeVerifier,
      redirectUri: DUENDE_CONFIG.REDIRECT_URI
    });

    return response;
  } catch (error) {
    throw error;
  }
}

/**
 * Refresh Duende access token via backend proxy
 * @param {string} refreshToken - Refresh token
 */
async function refreshDuendeToken(refreshToken) {
  try {
    // Call backend which will forward to Duende token endpoint
    const response = await axios.post('/duende/refresh-token', {
      refreshToken
    });

    return response;
  } catch (error) {
    throw error;
  }
}

/**
 * ⚠️ DEBUG ONLY: Direct exchange to Duende (bypassing backend)
 * WARNING: Exposes client_secret in browser - DO NOT USE IN PRODUCTION
 * @param {string} code - Authorization code
 * @param {string} codeVerifier - PKCE code verifier
 */
async function exchangeCodeForTokensDirect(code, codeVerifier) {
  try {
    console.warn('[DEBUG] Direct call to Duende - client_secret will be exposed!');
    
    const params = new URLSearchParams();
    params.append('client_id', DUENDE_CONFIG.CLIENT_ID);
    params.append('client_secret', DUENDE_CONFIG.CLIENT_SECRET);
    params.append('grant_type', 'authorization_code');
    params.append('code', code);
    params.append('redirect_uri', DUENDE_CONFIG.REDIRECT_URI);
    params.append('code_verifier', codeVerifier);

    const duendeUrl = `${DUENDE_CONFIG.BASE_URL}/connect/token`;
    
    console.log('[DEBUG] Direct request to:', duendeUrl);
    console.log('[DEBUG] Params:', {
      client_id: DUENDE_CONFIG.CLIENT_ID,
      grant_type: 'authorization_code',
      redirect_uri: DUENDE_CONFIG.REDIRECT_URI,
      codeLength: code?.length,
      codeVerifierLength: codeVerifier?.length
    });

    // Direct call to Duende (may fail due to CORS)
    const response = await axios.post(duendeUrl, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    console.log('[DEBUG] Direct response:', response.data);
    return response;
  } catch (error) {
    console.error('[DEBUG] Direct call failed:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    throw error;
  }
}

const DuendeAPI = {
  getDuendeConfig,
  getDuendeUserInfo,
  introspectDuendeToken,
  revokeDuendeToken,
  syncDuendeUser,
  testDuendeToken,
  exchangeCodeForTokens,
  refreshDuendeToken,
  exchangeCodeForTokensDirect // DEBUG ONLY
};

ApiCall.Duende = DuendeAPI;

export default ApiCall
